import React from 'react';
import HeaderFooterHOC from '../HOC/HeaderFooterHOC';

const CheckJePlek = (props) => {

    const latLng = (props.latLng.length > 1) ? props.latLng.split(',') : false;

    return (!!latLng && <div>
            <style>
                {`
                .iframe_checkjeplek {
                    height: 1850px;
                }
                @media all and (min-width: 649px) {
                    .iframe_checkjeplek {
                        height: 1350px;
                    }
                }
                `}
            </style>

            <iframe
                    src={`https://mijn.homeshowdomain.nl/checkjeplek?street=${props.street}&number=${props.number}&addition=${props.addition}&zipcode=${props.zipcode}&city=${props.city}`}
                    width="100%" className="iframe_checkjeplek" frameBorder="0"></iframe>
            </div>
    )

}

export default HeaderFooterHOC(CheckJePlek, 'checkjeplek');
